function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCommentRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11h14V9H9v2zm0 4h14v-2H9v2zm0 4h7v-2H9v2zM27 3H5a2 2 0 00-2 2v18a2 2 0 002 2h7l4 4 4-4h7a2 2 0 002-2V5a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconCommentRexFilled;